import React from 'react';
import { COLORS } from '../utils/constants.js';

export default function Spinner({ size = 16, color = COLORS.accent }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      style={{ animation: 'spin 1s linear infinite', display: 'inline-block' }}
    >
      <circle cx="12" cy="12" r="10" fill="none" stroke={`${color}33`} strokeWidth="3" />
      <path
        d="M12 2a10 10 0 019.8 8"
        fill="none"
        stroke={color}
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
}
